import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Article from "../pages/article/page";
import Comparison from "../pages/comparison/page";
import ShoesGuide from "../pages/shoes-guide/page";
import SafetyGuide from "../pages/safety-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/kakobuy-spreadsheet-guide",
    element: <Article />,
  },
  {
    path: "/kakobuy-vs-cssbuy-spreadsheet",
    element: <Comparison />,
  },
  {
    path: "/category-guide-shoes",
    element: <ShoesGuide />,
  },
  {
    path: "/complete-safety-guide",
    element: <SafetyGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;